module.exports = __webpack_public_path__ + "static/assets/bcg.e732da67.png";